import consumer from "./consumer"
import camelcaseKeysDeep from "camelcase-keys-deep"

export default function subscribeToChannel(
  channelName,
  receivedCallback,
  connectedCallback = () => {},
  disconnectedCallback = () => {},
  keepSnakeCase = false
) {
  if (!window.consumer) {
    window.consumer = consumer
  }
  return window.consumer.subscriptions.create(
    {
      channel: channelName
    },
    {
      connected: () => {
        console.log(`Subscribed to live updates from ${channelName}`)
        connectedCallback()
      },
      disconnected: () => {
        console.log(`Unsubscribed from live updates from ${channelName}`)
        disconnectedCallback()
      },
      received: (message) => {
        // message == 'reload' ? document.location.reload() : null

        // console.log(`Received update from ${channelName}`)
        // console.log({message})
        let parsedMessage
        if (keepSnakeCase) {
          parsedMessage = JSON.parse(message)
        } else {
          parsedMessage = camelcaseKeysDeep(JSON.parse(message))
        }

        receivedCallback(parsedMessage)
      }
    }
  )
}
